import React, { Component, Fragment } from "react";
import { Row } from "reactstrap";

import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import Trips from "../../../containers/pages/trips";
class PagesTrips extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.trips" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        <Trips />
      </Fragment>
    );
  }
}

export default PagesTrips;
